module.exports = __webpack_public_path__ + "img/H2.6f4ed8bd.png";